export const cifLv = ["301 151","<g fill='none'><path fill='#9E3039' d='M.5.5h300v150H.5z'/><path fill='#FFF' d='M.5 60.5h300v30H.5z'/></g>"]